import { t as RX_ABBREVIATION_FROM_STRING } from './color-591c5547.js';

const CODE_BACKSPACE = 8;
const CODE_BREAK = 19;
const CODE_DELETE = 46;
const CODE_DOWN = 40;
const CODE_END = 35;
const CODE_ENTER = 13;
const CODE_ESC = 27;
const CODE_HOME = 36;
const CODE_LEFT = 37;
const CODE_PAGEDOWN = 34;
const CODE_PAGEUP = 33;
const CODE_RIGHT = 39;
const CODE_SPACE = 32;
const CODE_UP = 38;

const PLACEMENT_TOP_START = 'top-start';
const PLACEMENT_TOP_END = 'top-end';
const PLACEMENT_BOTTOM_START = 'bottom-start';
const PLACEMENT_BOTTOM_END = 'bottom-end';
const PLACEMENT_RIGHT_START = 'right-start';
const PLACEMENT_RIGHT_END = 'right-end';
const PLACEMENT_LEFT_START = 'left-start';
const PLACEMENT_LEFT_END = 'left-end';

function getAbbreviation(text, limit) {
  var _a;
  if (typeof text != 'string' || !text) return '';
  return ((_a = text.match(RX_ABBREVIATION_FROM_STRING)) !== null && _a !== void 0 ? _a : []).reduce((previous, next) => previous + (+next === 0 || parseInt(next) ? parseInt(next) : next[0] || ''), '').toUpperCase().substring(0, limit);
}

/**
 * Determines whether the element `a` is a descendant of the element `b`.
 */
const isDescendant = (a, b) => {
  const {
    parentElement
  } = a;
  if (!parentElement) {
    return false;
  }
  if (b === parentElement) {
    return true;
  }
  return isDescendant(parentElement, b);
};

/**
 * Determines whether the `value` is a number.
 */
const isNumber = value => {
  return typeof value === 'number';
};

function extractCssVarName(string) {
  return string.replace(/var\((.*)\)/, ($1, $2) => {
    return $2;
  });
}

export { CODE_BACKSPACE as C, PLACEMENT_TOP_START as P, CODE_BREAK as a, CODE_DELETE as b, CODE_DOWN as c, CODE_END as d, CODE_ENTER as e, CODE_ESC as f, CODE_HOME as g, CODE_LEFT as h, CODE_PAGEDOWN as i, CODE_PAGEUP as j, CODE_RIGHT as k, CODE_SPACE as l, CODE_UP as m, PLACEMENT_TOP_END as n, PLACEMENT_BOTTOM_START as o, PLACEMENT_BOTTOM_END as p, PLACEMENT_RIGHT_START as q, PLACEMENT_RIGHT_END as r, PLACEMENT_LEFT_START as s, PLACEMENT_LEFT_END as t, getAbbreviation as u, isDescendant as v, isNumber as w, extractCssVarName as x };
